import { Icon, IconProps } from "@chakra-ui/react";

export default function SimpleDiamond(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 44 44"
      fill="none"
      {...props}
    >
      <circle cx="22" cy="22" r="22" fill="#0A043C" />
      <path
        d="M31 22.3761C29.1301 21.0973 27.2611 19.8184 25.3912 18.5387C24.1583 16.3747 22.9245 14.2116 21.6916 12.0476C20.4303 14.2116 19.1698 16.3747 17.9084 18.5387C15.9384 19.6657 13.9692 20.7928 12 21.9198C14.0802 23.2424 16.1604 24.5641 18.2407 25.8867C19.4043 27.9083 20.5688 29.9299 21.7325 31.9524C22.841 29.9308 23.9496 27.9091 25.0582 25.8867C27.0391 24.7168 29.0191 23.5469 31 22.377V22.3761Z"
        fill="#F59511"
      />
    </Icon>
  );
}
